// extracted by mini-css-extract-plugin
export var activeDot = "_2d-c";
export var buttonContainer = "_2d-9";
export var channelButton = "_2d-a";
export var content = "_2d-0";
export var contentFull = "_2d-2";
export var contentThird = "_2d-1";
export var contentWrapper = "_2d-7";
export var description = "_2d-5";
export var heightShort = "_2d-e";
export var image = "_2d-3";
export var imageContainer = "_2d-4";
export var selectButton = "_2d-d";
export var spinnerContainer = "_2d-b";
export var titleContent = "_2d-8";
export var titleWrapper = "_2d-6";